import React from 'react';

/** Returns a react-slick `customPaging` fn with labeled dot buttons. */
export function slickDotPaging(labelPrefix: string) {
  return (i: number) =>
    React.createElement(
      'button',
      {
        type: 'button',
        'aria-label': `${labelPrefix} ${i + 1}`,
      },
      String(i + 1),
    );
}
